import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, Form } from 'react-final-form';
import AuthContext from 'providers/Auth/Auth.context';
import EmailOrPhoneFieldWrapper from 'components/EmailOrPhoneFieldWrapper';
import { Link } from 'react-router-dom';
import { Button } from 'ncoded-component-library';
import useValidations from '../../hooks/useValidations';
import PasswordField from 'components/PasswordField';
import AlternateLogins from '../../components/AlternateLogins';
import { getResolveUrl } from 'utils';
import HelmetWrapper from 'components/HelmetWrapper';
import { LOGIN_ROUTE, SIGNUP_ROUTE } from 'data/global';
import { LoginForm } from 'models/AuthBody';

import './Login.styles.scss';

type LoginProps = Record<string, any>;

const Login: React.FC<LoginProps> = () => {
  const { loginRequest } = useContext(AuthContext);

  const validations = useValidations();

  const { t } = useTranslation();

  const helmetUrl = getResolveUrl(LOGIN_ROUTE);
  const title = 'Sign in to Resolve';
  const description =
    'Sign in to your Resolve account to manage your portfolio, browse business listings and make enquiries.';

  return (
    <>
      <HelmetWrapper title={title} description={description} url={helmetUrl} />

      <h1>{t('signIn')}</h1>

      <Form
        onSubmit={(values: LoginForm) => loginRequest(values)}
        render={({ handleSubmit, submitting, valid }) => (
          <>
            <form className="auth-login" onSubmit={handleSubmit}>
              <EmailOrPhoneFieldWrapper />

              <Field
                name="password"
                component={PasswordField}
                placeholder={t('password')}
                label={t('password')}
                withoutStrengthIndicator
                required
                validate={validations.password}
              />

              <div className="right-actions">
                <div>
                  <Link to="../forgot-password">{t('forgotPassword')}</Link>

                  <p>
                    {t('noAccount')}{' '}
                    <Link to={SIGNUP_ROUTE}>{t('createOne')}</Link>
                  </p>
                </div>

                <Button
                  type="submit"
                  disabled={!valid || submitting}
                  data-loading={submitting}
                >
                  {t('signIn')}
                </Button>
              </div>
            </form>
            <AlternateLogins />
          </>
        )}
      />
    </>
  );
};

export default Login;
